// che-lite域名配置
export const HOST_MAP = {
  'localhost:9528': 'http://localhost:3000',
  'che-dev.cheweijia.com': 'https://che-lite-dev.cheweijia.com',
  'che-test.cheweijia.com': 'https://che-lite-test.cheweijia.com',
  'che-test2.cheweijia.com': 'https://che-lite-test2.cheweijia.com',
  'che-pre.cheweijia.com': 'https://che-lite-gray.cheweijia.com',
  'che.cheweijia.com': 'https://che-lite.cheweijia.com',
  'che-prod2.cheweijia.com': 'https://che-lite.cheweijia.com',
}
